import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
require('highcharts/modules/heatmap')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
import { getHeatMapData } from '../../../api';

function getPointCategoryName(point, dimension) {
    let series = point.series,
        isY = dimension === 'y',
        axis = series[isY ? 'yAxis' : 'xAxis'];
    return axis.categories[point[isY ? 'y' : 'x']];
}

class HeatMap extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            chartConfig: null,
            loading: true
        }
    }

    getExportMenuItems = () => {
        // Hide the option for viewing the table in full screen in mobile
        let windowWidth = window.innerWidth;
        let windowHeight = window.innerHeight;
        let exportMenuItems = ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"];
        if (windowWidth < 780 || windowHeight < 700)
        {
            exportMenuItems = ["downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"];
        }

        return exportMenuItems;
    }

    updateDimension = () => {
        // Hide the option for viewing the table in full screen in mobile
        let exportMenuItems = this.getExportMenuItems();

        if (this.state.chartConfig.exporting.buttons.contextButton.menuItems.length != exportMenuItems.length)
        {
            this.setState( { chartConfig: {...this.state.chartConfig, exporting: {...this.state.chartConfig.exporting, buttons: { contextButton: { menuItems: exportMenuItems } } } } } );
        }
    }

    getLoadData(chart, dataset)
    {
        let exportMenuItems = this.getExportMenuItems();

        getHeatMapData(chart, dataset)
        .then( (res) => {
            let seriesToAdd = [ {
                visible: false,
                showInLegend: false
            }];

            for (let i = 0; i < res.resultset.data.length; i++)
            {
                seriesToAdd.push( { data: res.resultset.data[i] } );
            }

            this.setState( { 
                chartConfig: {
                    styledMode: true,
                    chart: {
                        type: 'heatmap',
                        marginTop: 90,
                        plotBorderWidth: 1,
                        scrollablePlotArea: {                            
                            minWidth: 450,
                            scrollPositionX: 0
                        },
                        events: {
                            load: function() 
                            {
                                let chart = this,
                                    colorAxis = chart.get('color-axs'), 
                                    min, max;
                      
                                seriesToAdd.forEach(function(series, index) 
                                {
                                    if (index) 
                                    {
                                        series.data.forEach(function(point) 
                                        {
                                            if (point.value != null)
                                            {
                                                if (min > point.value || !min) 
                                                {
                                                    min = point.value;
                                                } 
                                                else if (max < point.value || !max) 
                                                {
                                                    max = point.value;
                                                }
                                            }              
                                        });
                      
                                        colorAxis.update({
                                            min: min,
                                            max: max
                                        });
                      
                                        series.data.forEach(function(point) 
                                        {
                                            if (point.color == null && point.value != null)
                                            {
                                                point.color = colorAxis.toColor(point.value);
                                            }              
                                        });
                      
                                        chart.addSeries({
                                            data: series.data
                                        }, true, false);
                      
                                        min = undefined;
                                        max = undefined;
                                    } 
                                    else 
                                    {
                                        chart.addSeries(series, true, false);
                                    }
                                });
                            }
                        }
                    },
                    credits: {
                        enabled: false
                    },              
                    title: {
                        text: null
                    },
                    exporting: {
                        enabled: true,
                        filename: this.props.title,
                        buttons: {
                            contextButton: {
                                menuItems: exportMenuItems
                            }
                        },
                        sourceHeight: 1000
                    },
                    colorAxis: {
                        id: 'color-axs',
                        stops: [
                            [0, '#DCECEC'],
                            [1,'#4a8e91'],
                        ],
                        startOnTick: false,
                        endOnTick: false
                    },
                    legend: {
                        enabled: false
                    },                  
                    plotOptions: {
                        heatmap: {
                            nullColor: '#F0F0F0',
                            borderWidth: 1,
                            borderColor: '#7CB6EC',
                            dataLabels: {
                                enabled: true,
                                color: '#000000',
                                formatter: function () {
                                    if (this.point.value)
                                    {
                                        return Math.round(this.point.value);
                                    }
                                }
                            }
                        },
                        series: {
                            turboThreshold: 0
                        }
                    },
                    tooltip: {
                        formatter: function () {
                            return '<span style="color:'+this.point.color+'">● </span><b>' + getPointCategoryName(this.point, 'y') + '</b><br>' +
                            getPointCategoryName(this.point, 'x') + ': <b>' + Math.round(this.point.value);
                        }
                    },              
                    xAxis: {
                        categories: this.props.xAxisCategories,
                        labels: {
                            overflow: "allow",
                            autoRotation: false
                        },
                        opposite: true
                    },              
                    yAxis: {
                        categories: res.resultset.yAxisCategories,
                        title: null,
                        reversed: true
                    }
                },
                loading: false
            } )
        })
    }

    componentDidMount()
    {
        // If the dataset is an empty string, it means it will be received later
        if (this.props.dataset != '')
        {
            this.getLoadData(this.props.chart, this.props.dataset);
        }

        window.addEventListener('resize', this.updateDimension);
    }

    componentDidUpdate(prevProps)
    {
        if (prevProps.dataset != this.props.dataset)
        {
            this.getLoadData(this.props.chart, this.props.dataset);
            this.setState( { loading: true } )
        }
    }

    render()
    {
        let chart;
        if (this.state.loading == false)
        {
            chart = <HighchartsReact
                highcharts={Highcharts}
                options={ this.state.chartConfig }
                containerProps={{ className: 'chartContainer' }}
            />
        }
        
        return (
            <div className='chart-container'>
                { chart }
            </div>
        )
    }
}

export default HeatMap;